/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Vision_TextInputs */



/**
* | output |
* | --- |
* | "We keep ethics and inclusion at the centre of the business, with a dedicated operations team that looks after our clients and consultants." |
*
* @param {About_Vision_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_vision_text = /** @type {((inputs?: About_Vision_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Vision_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("我们始终把道德与包容放在企业的核心，由一支尽心尽责的运营团队照顾好我们的客户和顾问。")
	return /** @type {LocalizedString} */ ("We keep ethics and inclusion at the centre of the business, with a dedicated operations team that looks after our clients and consultants.")
});